// Entry point for the build script in your package.json
// Import Turbo
import "@hotwired/turbo-rails"

// Import and expose Bootstrap components
import { Alert, Button, Collapse, Dropdown, Tooltip } from 'bootstrap'
window.bootstrap = {
    Alert,
    Button,
    Collapse,
    Dropdown,
    Tooltip
};

// FontAwesome setup
import { library, dom } from '@fortawesome/fontawesome-svg-core';
import {
    faUser,
    faCoffee,
    faCircleInfo,
    faLink,
    faFileDownload,
    faQuestionCircle as faQuestionCircleSolid,
    faPrint,
    faExclamationTriangle,
    faTrash,
    faArrowRightFromBracket
} from '@fortawesome/free-solid-svg-icons';
import {
    faQuestionCircle as faQuestionCircleRegular,
    faCircleXmark
} from '@fortawesome/free-regular-svg-icons';

library.add(
    faUser,
    faCoffee,
    faCircleInfo,
    faQuestionCircleSolid,
    faQuestionCircleRegular,
    faLink,
    faFileDownload,
    faPrint,
    faExclamationTriangle,
    faCircleXmark,
    faTrash,
    faArrowRightFromBracket
);

// Watch for DOM changes to convert icons
dom.watch();

// Re-convert icons after Turbo navigation
document.addEventListener('turbo:load', () => {
    dom.i2svg();
});

document.addEventListener('turbo:render', () => {
    dom.i2svg();
});

// Import components
import "./components"


console.log('Envinorma application loaded')
